var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslate24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 5.35H10.936L10.1 2.5H4.4C3.355 2.5 2.5 3.355 2.5 4.4V16.75C2.5 17.795 3.355 18.65 4.4 18.65H11.05L12 21.5H19.6C20.645 21.5 21.5 20.645 21.5 19.6V7.25C21.5 6.205 20.645 5.35 19.6 5.35ZM7.4115 14.4605C5.274 14.4605 3.526 12.722 3.526 10.575C3.526 8.428 5.2645 6.6895 7.4115 6.6895C8.3995 6.6895 9.302 7.041 10.0145 7.706L10.081 7.763L8.9125 8.884L8.8555 8.8365C8.58 8.58 8.1145 8.276 7.4115 8.276C6.167 8.276 5.1505 9.3115 5.1505 10.575C5.1505 11.8385 6.167 12.874 7.4115 12.874C8.713 12.874 9.2735 12.0475 9.4255 11.487H7.326V10.0145H11.0785L11.088 10.081C11.126 10.2805 11.1355 10.461 11.1355 10.6605C11.1355 12.893 9.606 14.4605 7.4115 14.4605ZM13.14 12.836C13.4535 13.406 13.843 13.957 14.2705 14.451L13.7575 14.9545L13.14 12.836ZM13.8715 12.114H12.931L12.6365 11.126H16.427C16.427 11.126 16.104 12.3705 14.945 13.729C14.451 13.14 14.0995 12.5605 13.8715 12.114ZM20.55 19.6C20.55 20.1225 20.1225 20.55 19.6 20.55H12.95L14.85 18.65L14.0805 16.0185L14.9545 15.1445L17.5005 17.7L18.194 17.0065L15.6195 14.4605C16.4745 13.482 17.1395 12.323 17.4435 11.126H18.65V10.138H15.192V9.15H14.204V10.138H12.342L11.221 6.3H19.6C20.1225 6.3 20.55 6.7275 20.55 7.25V19.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate24Px);
export default __webpack_public_path__ + "static/media/translate_24px.9802c9619f8abedc0153ba45e98aa885.svg";
export { ForwardRef as ReactComponent };